<!--
 * @Author: DY
 * @Date: 2025-03-05 15:24:30
 * @LastEditTime: 2026-02-26 11:15:23
 * @Description: 汽运单登记（汽运）【运输管理】
 * @FilePath: \ShiMo_Mobile\src\views\transport\automobileWaybillRegistration\index.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="automobileWaybillRegistration commonListStyles">
            <HeaderNav
                :header-title="headerTitle"
                left-icon-name="2"
                right-icon-name="5"
                :extr="{ leftCallBack: swiperright, rightCallBack: rightClickFun, iconName: 'sm-shaixuan11' }"
            ></HeaderNav>
            <section>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list v-model="isUpLoading" finished-text="没有更多了!" :finished="finished" @load="onLoad">
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo">
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">汽运单号：{{ item.transport_number }}</span>
                                    </h4>
                                    <p class="itemStatus">
                                        {{ item.status_name }}
                                    </p>
                                    <div class="itemContent">
                                        <p>
                                            <img src="@/assets/images/icons/icon_1@2x.png" alt="">
                                            <span>铁运单号：{{ item.railway_number }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_29@2x.png" alt="">
                                            <span>客户名称：{{ item.client_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_28@2x.png" alt="">
                                            <span>物料代码：{{ item.material_code }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_28@2x.png" alt="">
                                            <span>短描述：{{ item.material_short_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_6@2x.png" alt="">
                                            <span>发货数量：{{ item.delivery_weight_new }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_7@2x.png" alt="">
                                            <span>发货日期：{{ item.delivery_date }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_10@2x.png" alt="">
                                            <span>备注：{{ item.remarks }}</span>
                                        </p>
                                    </div>
                                    <div class="itemBtn itemBtns">
                                        <van-button plain type="danger" v-if="[0, 4].includes(item.status) || (TransportType == 2 && item.status == 2)" @click="toDetail(item, 'edit')">
                                            办理
                                        </van-button>
                                        <van-button plain type="danger" v-if="[4].includes(item.status)" @click="returnOutbound(item)">
                                            退回出库
                                        </van-button>
                                        <van-button plain type="danger" v-if="[0, 1].includes(item.status) || (TransportType == 2 && item.status == 2)" @click="deleteAirWaybill(item)">
                                            删除
                                        </van-button>
                                        <van-button plain type="danger" v-if="![0, 2, 4].includes(item.status) || (TransportType != 2 && item.status == 2)" @click="toDetail(item, 'view')">
                                            查看
                                        </van-button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
                <button class="addBtn iconfont sm-icon-test" @click="toDetail(null, 'add')"></button>
            </section>
            <van-popup class="sideslip" v-model="popupShow" position="right" :style="{ width: '80%',height: '100%' }">
                <div class="screen">
                    <van-nav-bar title="筛选" right-text="取消" :style="`height: ${ $getNavHeight() }px;`" @click-right="popupShow = false"></van-nav-bar>
                    <section>
                        <dl>
                            <dt>汽运单号</dt>
                            <dd>
                                <van-field v-model="params.transport_number" placeholder="输入汽运单号"></van-field>
                            </dd>
                        </dl>
                        <dl v-if="TransportType === '2'">
                            <dt>铁运单号</dt>
                            <dd>
                                <van-field v-model="params.railway_number" placeholder="输入铁运单号"></van-field>
                            </dd>
                        </dl>
                        <dl>
                            <dt>客户名称</dt>
                            <dd>
                                <van-field v-model="params.client_name" placeholder="输入客户名称"></van-field>
                            </dd>
                        </dl>
                        <dl>
                            <dt>物料代码</dt>
                            <dd>
                                <van-field v-model="params.material" placeholder="输入物料代码"></van-field>
                            </dd>
                        </dl>
                        <dl>
                            <dt>发货状态</dt>
                            <dd class="selectList">
                                <p
                                    v-for="(item, index) in shipmentStatus"
                                    :key="`type_${index}`"
                                    :class="{'active': params.delivery_status.includes(item.value)}"
                                    @click="selectShipmentStatus(item)"
                                >
                                    {{ item.name }}
                                </p>
                            </dd>
                        </dl>
                    </section>
                    <footer>
                        <button @click="search">
                            确定
                        </button>
                        <button @click="resetSelect">
                            重置
                        </button>
                    </footer>
                </div>
            </van-popup>
        </div>
    </v-touch>
</template>

<script>
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'automobile-waybill-registration',
    mixins: [mixin_list],
    components: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'automobile-waybill-registration');
        }
        next();
    },
    data() {
        return {
            headerTitle: '',
            tableCode: 'transport_truck_register_truck',
            popupShow: false,
            shipmentStatus: [],
            params: {
                transport_number: '',
                railway_number: '',
                client_name: '',
                material: '',
                delivery_status: [],
            },
        };
    },
    watch: {},
    activated() {
        if (this.$route.params.isRefresh) {
            this.onRefresh();
        }
    },
    created() {
        this.cacheKey = Math.floor(Math.random() * 1000000000000 + 1);
        this.TransportType = this.$route.query.TransportType;
        if (this.TransportType === '1') {
            this.headerTitle = '汽运单登记（汽运）';
            this.tableCode = 'transport_truck_register_truck';
            this.shipmentStatus = [{
                name: '未提交',
                value: '0',
            }, {
                name: '待装货',
                value: '1',
            }, {
                name: '待出场',
                value: '4',
            }, {
                name: '待签收',
                value: '2',
            }, {
                name: '已签收',
                value: '3',
            }];
            this.params.delivery_status = ['0', '1', '4'];
        } else if (this.TransportType === '2') {
            this.headerTitle = '汽运单登记（铁运+汽运）';
            this.tableCode = 'transport_truck_register_truckWithRailway';
            this.shipmentStatus = [{
                name: '未提交',
                value: '0',
            }, {
                name: '待装货',
                value: '1',
            }, {
                name: '待签收',
                value: '2',
            }, {
                name: '已签收',
                value: '3',
            }];
            this.params.delivery_status = ['0', '1', '2'];
        }
    },
    mounted() {},
    computed: {},
    methods: {
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
        },
        rightClickFun() {
            this.popupShow = true;
        },
        loadRequestData() {
            const RequestData = {
                code: this.tableCode,
                cacheKey: this.cacheKey,
                page: this.pageIndex,
                limit: this.pageSize,
                transport_number: this.params.transport_number,
                client_name: this.params.client_name,
                material: this.params.material,
                delivery_status: this.params.delivery_status.toString(),
            };
            if (this.TransportType === '2') {
                RequestData.railway_number = this.params.railway_number;
            }
            return RequestData;
        },
        selectShipmentStatus(item) {
            if (this.params.delivery_status.includes(item.value)) {
                this.params.delivery_status.splice(this.params.delivery_status.indexOf(item.value), 1);
            } else {
                this.params.delivery_status.push(item.value);
            }
        },
        // 确认筛选
        search() {
            this.listData = [];
            this.pageIndex = 0;
            this.finished = false;
            this.popupShow = false;
            this.initPage();
        },
        // 重置筛选条件
        resetSelect() {
            this.params.transport_number = '';
            this.params.client_name = '';
            this.params.material = '';
            this.params.delivery_status = [];
        },
        toDetail(item = null, type = 'add') {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'automobileWaybillRegistrationForm',
                params: {
                    type,
                    data: item,
                    TransportType: this.TransportType,
                },
            });
        },
        returnOutbound(item) {
            this.$dialog.confirm({
                title: '退回出库',
                message: '您正在操作汽运单、销售出库单退回功能，是否确认退回？',
            }).then(async () => {
                const res = await this.returnRequest(item.id);
                if (res) {
                    this.$toast.success('退回出库成功。');
                    setTimeout(() => {
                        this.onRefresh();
                    }, 1000);
                }
            });
        },
        deleteAirWaybill(item) {
            this.$dialog.confirm({
                message: `确认删除汽运单 \n【${item.transport_number}】？`,
            }).then(async () => {
                const res = await this.deleteRequest(item.id);
                if (res) {
                    this.$toast.success('删除成功。');
                    setTimeout(() => {
                        this.onRefresh();
                    }, 1000);
                }
            });
        },
        deleteRequest(id) {
            return this.$axios.$get(`/interfaceApi/sale/transport_manage/transport_truck_delete?id=${id}`);
        },
        returnRequest(id) {
            return this.$axios.$get(`/interfaceApi/sale/transport_manage/return_to_outstock?id=${id}`);
        },
    },
    updated() {},
    destroyed() {},
};
</script>

<style lang="stylus" scoped>
.automobileWaybillRegistration
    width 100%
    height 100%
    background #F0F0F0
</style>
